import React from 'react';
import styles from './FJEditFloatingPanel.module.less';
import DeleteIcon from '../../../../../assets/svg/delete-black.svg?react';
import RestoreIcon from '../../../../../assets/svg/transcribe/recover.svg?react';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';

const FJEditFloatingPanel = props => {
    // eslint-disable-next-line react/prop-types
    const { showDelete, showRestore, position = { x: 0, y: 0 }, onClick } = props;
    return (
        <div className={styles.box} style={{ left: position.x, top: position.y - 4 }} onClick={onClick}>
            {showDelete && (
                <FJHoverBoardGradation className={styles.button} selectBgColor='#ffffff' active={true}>
                    <div className={styles.content}>
                        <DeleteIcon />
                    </div>
                </FJHoverBoardGradation>
            )}
            {showRestore && (
                <FJHoverBoardGradation className={styles.button} selectBgColor='#ffffff' active={true}>
                    <div className={styles.content}>
                        <RestoreIcon />
                    </div>
                </FJHoverBoardGradation>
            )}
        </div>
    );
};

export default FJEditFloatingPanel;
